{
  "version": 1,
  "asset_id": "b33e5b70-7a58-4454-904b-7466b56796f2",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/b33e5b70-7a58-4454-904b-7466b56796f2/sleeve-amateur-3-220.webp",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/b33e5b70-7a58-4454-904b-7466b56796f2/sleeve-amateur-3-220.webp",
  "original_filename": "sleeve-amateur-3-220.webp",
  "size": 5880,
  "content_type": "image/webp",
  "created_at": "2026-09-29T01:15:23Z"
}
